import { Box, Container, Grid, Stack, styled, Typography } from "@mui/material";
import React from "react";
import { allIcons, allImages } from "../../../assets";
import GlobalButton from "../../../components/CustomButton";

const MainView = styled(Box)(({ theme }) => ({
  position: "relative",
  height: "80vh",
  backgroundColor: "#000000",
  [theme.breakpoints.down("sm")]: {
    height: "auto",
  },

  "& .lpl_viewcon": {
    height: "inherit",
    position: "relative",
    height: "80vh",
    color: "#ffffff",
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
    textAlign: "center",
    zIndex: 999,
    [theme.breakpoints.down("sm")]: {
      height: "auto",
      padding: "2rem 16px",
    },
  },

  "& .lpl_text_pr": {
    fontWeight: 600,
    fontSize: "4rem",
    [theme.breakpoints.down("sm")]: {
      fontSize: "2rem",
    },
  },
  "& .lpl_text_sr": {
    fontWeight: 300,
    maxWidth: "900px",
    [theme.breakpoints.down("sm")]: {
      fontSize: "1rem",
    },
  },
}));

function Banner() {
  return (
    <MainView>
      <Container maxWidth={"lg"} className="lpl_viewcon">
        <Typography variant="h1" className="lpl_text_pr">
          Close more deals, faster
        </Typography>
        <Typography mt={2.5} variant={"h6"} className={"lpl_text_sr"}>
          See which plan is right for you. Try the all-in-one sales
          communication that unifies your outreach, engagement, and automation
          in a flexible CRM.
        </Typography>
        <Stack
          mt={{ xs: 6, md: 4 }}
          direction={{ xs: "column", sm: "row" }}
          alignItems={"center"}
          gap={1.5}
        >
          <GlobalButton
            btnText={"Lets start your trial !"}
            styleProps={{ width: { xs: "100%", md: 250 } }}
          />
        </Stack>
      </Container>
    </MainView>
  );
}

export default Banner;
